import { render, staticRenderFns } from "./FreezeModal.vue?vue&type=template&id=6b2b3f96&scoped=true"
import script from "./FreezeModal.vue?vue&type=script&lang=js"
export * from "./FreezeModal.vue?vue&type=script&lang=js"
import style0 from "./FreezeModal.vue?vue&type=style&index=0&id=6b2b3f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b3f96",
  null
  
)

export default component.exports